import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {LocalStorageService} from 'src/app/local-storage.service';
import {MainDataModels} from 'src/app/models/maindata-models';
import {MainDataService} from 'src/app/services/main-data.service';
import {NotizEintragComponent} from '../pendenzen/notiz-eintrag/notiz-eintrag.component';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {MatDialog} from '@angular/material/dialog';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-meine-notizen',
    templateUrl: './meine-notizen.component.html',
    styleUrls: ['./meine-notizen.component.scss'],
})
export class MeineNotizenComponent implements OnInit {
    public dbNotizen: MainDataModels.Notiz[] = [];
    public swissDatumFormat = {type: 'date', format: 'dd.MM.yyyy'};
    public notizID!: any;
    displayedColumns: string[] = ['wasRead', 'title', 'date', 'notiz', 'createdBy', 'position'];
    wasRead: boolean = false;
    public innerWidth: any;
    private currNotizMitBenutzern?: MainDataModels.NotizMitBenutzer;
    private destroyRef = inject(DestroyRef);

    constructor(
        private svcMainData: MainDataService,
        private localStorageService: LocalStorageService,
        private svcMessageBox: MessageBoxService,
        public dialog: MatDialog,
        private swissSettings: SwissSettingsService,
    ) {
    }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        this.loadNotizen();
    }

    loadNotizen() {
        // Pendenzen Live vom Webservice holen
        this.svcMainData.getUserNotes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (res) => {
                this.dbNotizen = res.sort((a, b) => {
                    const dateA = a.modified || new Date();
                    const dateB = b.modified || new Date();

                    if (dateA < dateB) {
                        return -1;
                    }
                    if (dateA > dateB) {
                        return 1;
                    }
                    return 0;
                });
                this.svcMainData.setNoteCount(res);
            },
            error: () => {
                // Webservice nicht verfügbar --> aus IndexedDB laden
            },
        });
    }

    showNotizDetail(notiz: MainDataModels.Notiz) {
        this.svcMainData.markNoteAsRead(notiz.noteID).subscribe({
            next: (res) => {
                notiz.wasRead = res ? 1 : 0;
            },
            error: () => {
            }
        });

        this.svcMainData.loadNoteByID(notiz.noteID).subscribe({
            next: (res) => {
                var dialogRef = this.dialog.open(NotizEintragComponent, {
                    disableClose: true,
                    width: '800px',
                    data: res,
                });

                dialogRef.afterClosed().subscribe({
                    next: (result) => {
                        this.currNotizMitBenutzern = result;
                        if (this.currNotizMitBenutzern) {
                            // Update Informations
                            this.svcMainData.saveNotiz(this.currNotizMitBenutzern).subscribe({
                                next: () => {
                                    this.svcMessageBox.showSuccess(
                                        'Die Notiz wurde erfolgreich gespeichert.',
                                        'Erfolgreich'
                                    );
                                    this.loadNotizen();
                                    this.svcMainData.refreshNoteCount();
                                },
                                error: (error) => {
                                    console.log(error);
                                    this.svcMessageBox.showError(
                                        'Die Notiz konnte nicht gespeichert werden!!',
                                        '!! FEHLER !!'
                                    );
                                },
                            });
                            if (this.swissSettings.getWebConfig().debugMode) {
                                console.log(
                                    'Dialog Resultat (currNotizMitBenutzern): ',
                                    this.currNotizMitBenutzern
                                );
                            }
                        }
                        this.svcMainData.setNoteCount(this.dbNotizen);
                    },
                });
            },
        });
    }
}
